<template slot-scope="tour">
    <transition name="fade">
        <v-step
                v-if="tour.steps[tour.currentStep]"
                :key="tour.currentStep"
                :step="tour.steps[tour.currentStep]"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :skip="tour.skip"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.customOptions.labels"
                :enabled-buttons="tour.customOptions.enabledButtons"
                :highlight="tour.customOptions.highlight"
                :debug="tour.customOptions.debug">
            <template>
                <div slot="header"></div>
                <div slot="content">
                    <v-card>
                        <v-card-title>
                            <div class="d-flex justify-start" v-html="tour.steps[tour.currentStep].title"></div>
                            <div class="d-flex ml-auto justify-end" v-html="tour.steps[tour.currentStep].graphic"></div>
                        </v-card-title>
                        <v-card-subtitle v-if="!subSteps || NODE_ENV !== 'production'">
                            <sup>Tip {{ tour.currentStep + 1 }} of {{ tour.steps.length }} <span class="text-h5" v-if="NODE_ENV !== 'production'">(step: {{ tour.currentStep }})</span></sup>
                        </v-card-subtitle>
                        <v-card-text class="text-left">
                            <div v-html="tour.steps[tour.currentStep].content"></div>
                        </v-card-text>
                        <v-card-actions v-if="!subSteps || $vuetify.breakpoint.mobile">
                            <v-btn v-if="tour.currentStep >= 2" @click="tour.previousStep" text class="btn btn-primary">Previous step</v-btn>
                            <v-spacer v-if="tour.currentStep >= 2"></v-spacer>
                            <v-btn @click="tour.stop" text class="btn btn-primary">{{ tour.isLast ? 'Finished' : 'Close' }}</v-btn>
                            <v-spacer v-if="!tour.isLast"></v-spacer>
                            <v-btn v-if="!tour.isLast" @click="tour.nextStep" text class="btn btn-primary">Next step</v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
                <div slot="actions"></div>
            </template>
        </v-step>
    </transition>
</template>
<style>
#nft-create-component.v-tour__target--highlighted {
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
}
.v-step {
    max-width: 640px !important;
    background: red !important;
    padding: 7px !important;
    border-radius: 5px !important;
}
.v-tour__target--highlighted {
    -webkit-box-shadow: 0 0 0 2px rgb(61, 60, 60);
    box-shadow: 0 0 0 2px red;
    border-radius: 5px;
}
#tour-step-brand-name-size.v-tour__target--highlighted {
    margin: 20px 0 0 20px;
}
#tour-step-color.v-tour__target--highlighted {
    margin: 10px 0 0 0;
    max-width: unset;
}
#tour-step-left-front-right-back {
    margin: 10px 0 10px 0;
    display: flex;
}
#tour-step-nude {
    margin: 10px 0 10px 0;
}
#tour-step-fitting {
    margin: 10px 0 10px 0;
}
#tour-step-secret {
    margin: 10px 0 10px 0;
}
#tour-step-price {
    padding: 10px 0 10px 0;
}
#tour-step-create {
    margin: 10px 0 10px 0;
}
</style>
<script>
export default {
    name: "TsNFTCreateForm",
    computed: {
        tour() {
            return this.$parent ? this.$parent : undefined;
        },
        subSteps() {
            return this.tour.$options.propsData.name.match(/substeps/i);
        },
        NODE_ENV() {
            return process.env.NODE_ENV
        }
    },
    watch: {
        this: {
            handler: function (vm) {
                this.$set(this, "tour", vm.$parent);
                console.log("vm: ", vm, this.tour.labels);
            },
            deep: true,
        },
    },
    mounted() {
        
    },
};
</script>